import { useEffect } from 'react';
import { useTrackingStore } from './index';

export default function useViewTracking(category, action, label) {
  useEffect(() => {
    useTrackingStore.getState().trackEvent({ category, action, label });
  }, []);
}
